import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '@/components/public/home/Hero';
import WhyKR from '@/components/public/home/WhyKR';
import AgencyHubShowcase from '@/components/public/home/AgencyHubShowcase';
import AgentPersonas from '@/components/public/home/AgentPersonas';
import TrainingDevelopment from '@/components/public/home/TrainingDevelopment';
import EventsSection from '@/components/public/home/EventsSection';
import BecomeAgentCTA from '@/components/public/home/BecomeAgentCTA';
import TrustSection from '@/components/public/home/TrustSection';

export default function HomePage() {
  const { hash } = useLocation();

  // Smooth-scroll to hashed sections (nav links like /#why-kr).
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [hash]);

  return (
    <div data-testid="public-home">
      <Hero />
      <WhyKR />
      <AgencyHubShowcase />
      <AgentPersonas />
      <TrainingDevelopment />
      <EventsSection />
      <TrustSection />
      <BecomeAgentCTA />
    </div>
  );
}
